// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"522":"16906b13","533":"f150e8a3","563":"0cb0b947","843":"715cf37e","897":"bb76593d"}[chunkId] + ".chunk.css";
};